// eslint-disable-next-line @nx/enforce-module-boundaries
import 'apps/locale'
import { Environment } from '@wm-front/shared/environment'
import type { DatadogConfiguration } from '@wm-front/core-tools'

export const environment: Environment = {
  production: true,
  appName: 'wm-front',
  graphqlUrl: 'https://api.wemaintain.io/gateway/graphql',
  segmentApiKey: 'ka39sO8r8tRLmZED3dLJu22SwzQiLvfc',
  segmentEnabled: true,
  amplitudeApiKey: '6bb090de5c0cf6c3a82a7eb1a1e74376',
  hotjarApiKey: '1688951',
  oauth: {
    scope: 'email+profile',
    clientId:
      '271062699605-iilneh2huck09g7sgco17sbpc4282dqa.apps.googleusercontent.com',
    callbackURI: 'https://api.wemaintain.io/users/oauth/google/callback',
  },
  launchDarkly: {
    key: '5e188020843a7b0851084da0',
    allAttributesPrivate: true,
    defaultUser: {
      key: 'anonymous',
    },
    options: {
      streaming: true,
    },
  },
  datadog: {
    applicationId: 'cbdb5972-9fac-41e9-ba02-a194688e28ec',
    clientToken: 'pub25445381ae0dc76c64f6875fd06c9f15',
    site: 'datadoghq.eu',
    service: 'client-platform',
    env: 'production',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    forwardErrorsToLogs: true,
    // Datadog headers only, as with SDK 2.x (traceparent would need to be allowed by the API CORS policy)
    allowedTracingUrls: [
      { match: 'https://api.wemaintain.io', propagatorTypes: ['datadog'] },
    ],
  } as DatadogConfiguration,
  cubejsV2ApiUrl: 'https://api.wemaintain.io/cubi/api/v1',
  socketUrl: 'https://api.wemaintain.io',
  clerk: {
    publishableKey: 'pk_live_Y2xlcmsubXkud2VtYWludGFpbi5jb20k',
  },
}
